import { PayloadAction, createSlice } from '@reduxjs/toolkit';
interface Filters {
  name?: string | number;
  ordering?: string;
}

export type DataState = {
  isLoading: boolean;
  isRefreshData: boolean;
  error: any;
  data: any;
  filters: Filters;
  dataTotalCount: number;
  dataCurrentCount: number;
};

const initialState: DataState = {
  error: null,
  data: null,
  isLoading: false,
  isRefreshData: false,
  filters: {},
  dataTotalCount: 0,
  dataCurrentCount: 0,
};

export const CompaniesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    loadCompanies(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
    setLoadingCompanies(state, action: PayloadAction<any>) {
      state.isLoading = action.payload;
    },
    setErrorCompanies(state, action: PayloadAction<any>) {
      state.error = action.payload;
    },
    setRefreshData(state, action: PayloadAction<any>) {
      state.isRefreshData = action.payload;
    },
    setTotalCountData(state, action: PayloadAction<any>) {
      state.dataTotalCount = action.payload;
    },
    setCurrentCountData(state, action: PayloadAction<any>) {
      state.dataCurrentCount = action.payload;
    },
    setFilters(state, action: PayloadAction<any>) {
      state.filters = action.payload;
    }
  },
});

export default CompaniesSlice.reducer;
